import { useMutation } from "@apollo/react-hooks";
import { ChoiceList, Modal } from "@shopify/polaris";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { ENABLED_48H_FULFILLMENT } from "../../../graphql/mutations";
import { arrInvalid, handleError } from "../../../helper";
import { useToastContext } from "../../shared/ToastContext";
import useTimeout from "../../../hooks/useTimeout";

export function Enabled48HFulfillment({
    value,
    orderIDs,
    open,
    onClose,
    refetch,
    handleCompleted,
}) {
    // Props
    const { enabled48HFulfillment } = value || {};

    const [selected, setSelected] = useState([!!enabled48HFulfillment]);

    // Context
    const { toggleToast, setNotify } = useToastContext();

    // Mutation
    const [setDelay] = useTimeout()
    const [update, { loading }] = useMutation(ENABLED_48H_FULFILLMENT, {
        onCompleted: () => {
            setNotify({
                msg: "Enabled/Disabled 48H Fulfillment success.",
                err: false,
            });

            onClose && onClose(false);
            setDelay(() => {
                refetch && refetch();
                handleCompleted && handleCompleted();
            }, 1500);

        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    useEffect(() => {
        if (enabled48HFulfillment == null) return;
        setSelected([!!enabled48HFulfillment]);
    }, [enabled48HFulfillment]);


    // Actions
    const enabled = selected[0];
    const handleSubmit = useCallback(() => {
        if (arrInvalid(orderIDs)) {
            return;
        }

        toggleToast && toggleToast();
        setNotify({ msg: null, err: false });
        update({
            variables: {
                ids: orderIDs,
                enabled,
            },
        });
    }, [enabled, orderIDs, update, toggleToast, setNotify]);

    return (
        <Modal
            title="Enabled 48H Fulfillment"
            open={open}
            onClose={onClose}
            sectioned
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <ChoiceList
                choices={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                ]}
                selected={selected}
                title="Enabled 48H Fulfillment"
                onChange={(selected) => setSelected(selected)}
            />
        </Modal>
    );
}
